export default {"src":"/_next/static/media/SEPA.10ef95e2.svg","height":349,"width":1024};